import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { sendSentryClientError } from 'shared/lib';

import { setLastConfirmationResult, useConfirmationRequestDeliveryMutation } from 'entities/preApprovals';

import { MAX_RETRY_TIME_IN_SECONDS } from '../PreApprovalConfirmationForm.config';

import { CONFIRMATION_STATUS_CODES } from './constants';
import { useApplyTimerFromConfirmationResponse } from './useApplyTimerFromConfirmationResponse';

export const useInitialSendSmsConfirmation = (preapprovalOfferId: string) => {
  const dispatch = useDispatch();
  const applyTimerFromResponse = useApplyTimerFromConfirmationResponse();
  const [confirmationRequestDelivery] = useConfirmationRequestDeliveryMutation();

  return useCallback(async () => {
    try {
      const res = await confirmationRequestDelivery({ offerId: preapprovalOfferId }).unwrap();
      dispatch(setLastConfirmationResult(res));
      applyTimerFromResponse(res);
      return {
        isTooManyRequests:
          res.statusCode === CONFIRMATION_STATUS_CODES.TOO_MANY_REQUESTS &&
          !!res.retryAfterInSeconds &&
          // Если время, через которое можно повторить запрос, больше 10 минут
          res.retryAfterInSeconds > MAX_RETRY_TIME_IN_SECONDS,
        isSendDoubleSms: res.statusCode === CONFIRMATION_STATUS_CODES.SEND_DOUBLE_SMS,
      };
    } catch (e) {
      sendSentryClientError(e as Error);
      return {
        isTooManyRequests: false,
        isSendDoubleSms: false,
      };
    }
  }, [confirmationRequestDelivery, preapprovalOfferId, dispatch, applyTimerFromResponse]);
};
